import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react'

import { Button } from '@/components/ui'

interface GuideActionsProps {
  isFirstStep: boolean
  isLastStep: boolean
  onBack: () => void
  onNext: () => void
  onFinish: () => void
}

export const GuideActions = ({
  isFirstStep,
  isLastStep,
  onBack,
  onNext,
  onFinish,
}: GuideActionsProps) => (
  <div className="flex items-center justify-end gap-3">
    {!isFirstStep && (
      <Button theme="ghost" size="lg" className="mr-auto px-3" onClick={onBack}>
        <ArrowLeftIcon aria-hidden />
        Back
      </Button>
    )}
    <Button size="lg" onClick={isLastStep ? onFinish : onNext}>
      {isLastStep ? 'Start uploading' : 'Next'}
      {!isLastStep && <ArrowRightIcon aria-hidden />}
    </Button>
  </div>
)
